import React, { Fragment } from "react";
import Footer from "./Footer";
import HeroPhoto from "./HeroPhoto";

const OtrosConocimientos = () => {
  const contactos = [
    { label: "Email", value: "koeman1976sf@gmail.com", href: "mailto:koeman1976sf@gmail.com" },
    { label: "Web", value: "joseanavas.com", href: "https://www.joseanavas.com" },
    {
      label: "LinkedIn",
      value: "Perfil",
      href: "https://www.linkedin.com/in/jose-antonio-navas-ruiz-25694859/",
    },
    { label: "X / Twitter", value: "@koeman1976", href: "https://twitter.com/koeman1976?s=09" },
  ];

  const bloques = [
    {
      title: "Tecnologías de desarrollo",
      level: "Alta",
      tags: ["Back-end", "Integración", "Arquitectura"],
      items: [
        "Web services (SOAP/REST), Web API",
        "jQuery",
        "Bootstrap 4",
        "LINQ",
        "AJAX",
        ".NET Framework 4.7",
        "Entity Framework",
        "Microservicios (conceptos / implementación según proyecto)",
        "Node.js (uso puntual)",
      ],
    },
    {
      title: "Complementarios al desarrollo",
      level: "Alta",
      tags: ["DevOps", "Operación", "Formato de datos"],
      items: ["Git", "JSON", "XML", "Microsoft Teams", "Azure DevOps", "IIS", "CSS"],
    },
    {
      title: "Herramientas y plataformas",
      level: "Alta",
      tags: ["Reporting", "Componentes", "Infra"],
      items: ["SQL Server Reporting Services (SSRS)", "Crystal Reports", "Telerik UI", "Windows Server"],
    },
  ];

  return (
    <Fragment>
      <main className="cvMain">
        {/* HERO */}
        <section className="cvHero cvHero2026">
          <div className="cvContainer cvHeroGrid">
            <div className="cvHeroLeft">
              <p className="cvKicker">Conocimientos</p>
              <h1 className="cvTitle">Otros conocimientos</h1>
              <p className="cvSubtitle">
                Responsable IT / .NET Senior · Integración · Operación · Reporting
              </p>

              <div className="cvMeta">
                <span className="cvMetaItem">Madrid</span>
                <span className="cvMetaDot" aria-hidden="true" />
                <span className="cvMetaItem">Fiabilidad · Entrega · Mantenimiento</span>
              </div>
            </div>

            <aside className="cvHeroRight" aria-label="Fotografía">
              <HeroPhoto />
            </aside>
          </div>
        </section>

        {/* CONTENIDO */}
        <section className="cvSection">
          <div className="cvContainer cvTwoCol">
            {/* Lateral */}
            <aside className="cvSide">
              <div className="cvCard">
                <h2 className="cvH2">Resumen</h2>
                <p className="cvP">
                  Conjunto de herramientas y tecnologías que complementan el trabajo diario en desarrollo
                  y operación: integración, DevOps, reporting e infraestructura.
                </p>
              </div>

              <div className="cvCard">
                <h2 className="cvH2">Contacto</h2>
                <ul className="cvList">
                  {contactos.map((c) => (
                    <li key={c.label} className="cvListItem">
                      <span className="cvMuted">{c.label}:</span>{" "}
                      <a className="cvLink" href={c.href} target="_blank" rel="noreferrer">
                        {c.value}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="cvCard">
                <h2 className="cvH2">Idiomas</h2>
                <ul className="cvList">
                  <li className="cvListItem">
                    Español <span className="cvMuted">(Nativo)</span>
                  </li>
                  <li className="cvListItem">
                    Inglés <span className="cvMuted">(Medio/Alto)</span>
                  </li>
                </ul>
              </div>
            </aside>

            {/* Principal */}
            <div className="cvContent">
              <div className="cvSectionHead">
                <h2 className="cvH2">Áreas</h2>
                <p className="cvMuted">Tecnologías agrupadas por ámbito y nivel de experiencia.</p>
              </div>

              <div className="cvTimeline">
                {bloques.map((b) => (
                  <article key={b.title} className="cvCard cvItem">
                    <div className="cvItemHead">
                      <div>
                        <h3 className="cvH3">{b.title}</h3>
                        <p className="cvMuted">Experiencia: {b.level}</p>
                      </div>

                      <div className="cvTags">
                        {b.tags.map((t) => (
                          <span key={t} className="cvTag">
                            {t}
                          </span>
                        ))}
                      </div>
                    </div>

                    <ul className="cvBullets">
                      {b.items.map((it) => (
                        <li key={it}>{it}</li>
                      ))}
                    </ul>
                  </article>
                ))}
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </Fragment>
  );
};

export default OtrosConocimientos;
